import { memo } from 'react';

import type { FlexContainerProps } from '@/components/atomic/atoms/layout/flex-container/typings';
import type { ViewProps } from '@/components/atomic/atoms/layout/view/typings';
import Styled from '@/components/atomic/atoms/navigation/link/styled';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';
import normalisePath from '@/utils/path-helper';

const LinkComponent: React.FC<
	FlexContainerProps &
		ViewProps &
		BasicComponentProps &
		React.AnchorHTMLAttributes<HTMLAnchorElement> &
		React.AnchorHTMLAttributes<HTMLElement> &
		React.AnchorHTMLAttributes<HTMLBaseElement>
> = (props) => <Styled {...props} href={normalisePath(props.href)} />;

const Link = memo(withExposer(LinkComponent, 'link'));

export default Link;
